const animatedScrollObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("enter");
                animatedScrollObserver.unobserve(entry.target);
            }
        })
    }
);

export default {
    mounted (element) {
        element.classList.add("before-enter");
        animatedScrollObserver.observe(element);
    }
}